import { getWebPlaysDbLazy, AUTO_LAUNCHED_ACTIONS_STORE_NAME } from './dbService'

async function getStore(
  this: AutoLaunchedActionsDbStore,
  mode: IDBTransactionMode = 'readonly',
): Promise<IDBObjectStore> {
  if (!this.dbPromise) {
    this.dbPromise = getWebPlaysDbLazy()
  }

  const db = await this.dbPromise
  return db.transaction(AUTO_LAUNCHED_ACTIONS_STORE_NAME, mode).objectStore(AUTO_LAUNCHED_ACTIONS_STORE_NAME)
}

/**
 * Provides persistent browser storage of auto-launched action IDs for a given playbook.
 * This allows to track which actions have already been auto-launched
 * and avoid re-launching them on subsequent visits
 */
export class AutoLaunchedActionsDbStore {
  dbPromise: Promise<IDBDatabase> | null = null

  async get(playbookId: string): Promise<number[] | null | undefined> {
    const store = await getStore.call(this, 'readonly')
    const request = store.get(playbookId)

    return new Promise<number[] | null>((resolve, reject) => {
      request.onsuccess = () => resolve(request.result?.actionIds)
      request.onerror = () => reject(request.error)
    })
  }

  async save(playbookId: string, actionIds: number[]) {
    const store = await getStore.call(this, 'readwrite')

    const record = { playbookId, actionIds }

    const request = store.put(record)
    return new Promise<void>((resolve, reject) => {
      request.onsuccess = () => resolve()
      request.onerror = () => reject(request.error)
    })
  }

  async remove(playbookId: string) {
    const store = await getStore.call(this, 'readwrite')
    const request = store.delete(playbookId)

    return new Promise<void>((resolve, reject) => {
      request.onsuccess = () => resolve()
      request.onerror = () => reject(request.error)
    })
  }
}

export const instance = new AutoLaunchedActionsDbStore()
